<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_vi"></a><a id="page_vii"></a>Contents</h2>
<p class="toc"><a href="#/xhtml/acknowledgments#ack">Acknowledgments</a></p>
<p class="toc"><a href="#/xhtml/abbreviations#abb">Abbreviations, Names, and Sinhala Terms</a></p>
<p class="toct"><a href="#/xhtml/introduction#int">Introduction: Political Ethnography of Disaster</a></p>
<p class="toca"><a href="#/xhtml/introduction#intlev1"><em>Wijitha’s Story</em></a></p>
<p class="toc1"><span href="#/xhtml/chapter1#ch1" title="Link target outside of Sample"><strong>1</strong>  That Day: Chaos and Solidarity</span></p>
<p class="toca"><span href="#/xhtml/chapter1#ch1lev1" title="Link target outside of Sample"><em>Dr. Priyanka’s Story</em></span></p>
<p class="toc1"><span href="#/xhtml/chapter2#ch2" title="Link target outside of Sample"><strong>2</strong>  Deaths: Fate and Vulnerability</span></p>
<p class="toca"><span href="#/xhtml/chapter2#ch2lev1" title="Link target outside of Sample"><em>Pradeep and Manoj’s Story</em></span></p>
<p class="toc1"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample"><strong>3</strong>  Short-Term Camps: Chaos and the Crafting of Order</span></p>
<p class="toca"><span href="#/xhtml/chapter3#ch3lev1" title="Link target outside of Sample"><em>Sumendra’s Story</em></span></p>
<p class="toc1"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample"><strong>4</strong>  Housing: Temporary Shelters, Permanent Homes, and the Buffer Zone</span></p>
<p class="toca"><span href="#/xhtml/chapter4#ch4lev1" title="Link target outside of Sample"><em>Lalitha’s Story</em></span></p>
<p class="toc1"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample"><strong>5</strong>  Dangerous Liaisons: The Power, Peril, and Politics of Mediating between Donors and Recipients</span></p>
<p class="toca"><span href="#/xhtml/chapter5#ch5lev1" title="Link target outside of Sample"><em>Jagath’s Story</em></span></p>
<p class="toc1"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample"><strong>6</strong>  Business Recovery: Tourism and Construction</span></p>
<p class="toca"><span href="#/xhtml/chapter6#ch6lev1" title="Link target outside of Sample"><em>Dayawansa’s Story</em></span></p>
<p class="toc1"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample"><strong>7</strong>  Reconstructing Class: Discourse on Theft, Loot, Cheating, and Gifts</span></p>
<p class="toca"><span href="#/xhtml/chapter7#ch7lev1" title="Link target outside of Sample"><em>Fazmina’s Story</em></span></p>
<p class="toc1"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample"><strong>8</strong>  The Politics of Corruption: Accusations and Rebuttals</span></p>
<p class="toca"><a id="page_viii"></a><span href="#/xhtml/chapter8#ch8lev1" title="Link target outside of Sample"><em>Tharindu’s Story</em></span></p>
<p class="toc1"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample"><strong>9</strong>  Citizenship and Ethnicity: The Tsunami and the Civil War</span></p>
<p class="toct"><span href="#/xhtml/conclusion#con" title="Link target outside of Sample">Conclusion</span></p>
<p class="toct1"><span href="#/xhtml/notes#note" title="Link target outside of Sample">Notes</span></p>
<p class="tocx"><span href="#/xhtml/references#ref" title="Link target outside of Sample">References</span></p>
<p class="tocx"><span href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?ac2737b2